import { captureException } from '@sentry/nextjs';
import { HeaderProps, FooterProps } from '@spotify-internal/masthead-react';

// Experiment to reduce subnav in MASTHEAD
// https://ghe.spotify.net/orcas/www-masthead-api/pull/440
const SIMPLIFY_MASTHEAD_TEST_FEATURE = 'supportSiteExperiment';

export const getMasthead = async (
  market: string,
  simplifyMasthead: boolean,
): Promise<{
  header?: HeaderProps;
  footer?: FooterProps;
}> => {
  const MASTHEAD_API = 'https://www.spotify.com/api/masthead/v1/masthead';
  const queryParams = simplifyMasthead
    ? new URLSearchParams({ testFeature: SIMPLIFY_MASTHEAD_TEST_FEATURE, market })
    : new URLSearchParams({ market });

  try {
    const res = await fetch(`${MASTHEAD_API}?${queryParams}`, { credentials: 'include' });

    if (!res.ok) {
      throw new Error(`Failed to fetch masthead data: ${res.status}`);
    }

    return await res.json();
  } catch (e) {
    captureException(e);
    return {};
  }
};
